import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { HomeLayout } from './components/home/HomeLayout'
import { MainLayout } from './components/layout'
import { HelpPage } from './pages/HelpPage'
import { GettingStartedPage } from './pages/help/GettingStartedPage'
import { AddToHomeScreenPage } from './pages/help/AddToHomeScreenPage'
import { AppHeader, ErrorBoundary } from './components/ui'
import { AppShell } from '@mantine/core'

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppShell header={{ height: 70 }}>
          <AppHeader />
          <Routes>
            {/* Home page has its own special layout */}
            <Route path="/" element={<HomeLayout />} />

            {/* Help pages use the common MainLayout */}
            <Route path="/help" element={
              <MainLayout>
                <HelpPage />
              </MainLayout>
            } />
            <Route path="/help/getting-started" element={
              <MainLayout>
                <GettingStartedPage />
              </MainLayout>
            } />
            <Route path="/help/add-to-home-screen" element={
              <MainLayout>
                <AddToHomeScreenPage />
              </MainLayout>
            } />
          </Routes>
        </AppShell>
      </BrowserRouter>
    </ErrorBoundary>
  )
}

export default App
